import { useContext, useEffect, useState } from "react";
import { useFilters } from "../Filters.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { operation_type_id } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/options";
import { getOperationValue } from "src/utils/Functions";

type OperationTypeProps = {
	selectedValue: number;
	filterChanged: (values: any) => void;
	labeled?: boolean;
	inputType?: string;
}
	
const useOperationType = ({
	labeled = false,
	inputType = "select",
	filterChanged,
}: OperationTypeProps) => {
	const { country_code } = useContext(ConfigStateContext);
	const { filters, filtersTags } = useFilters();
	const [selectedValue, setSelectedValue] = useState("");
	const operationTypeIdByCountry = operation_type_id.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : ""));
    const operationTypeList = operationTypeIdByCountry.map((type) => ({ text: type.text, value: type.value, projects: type.projects }));

	const onChange = newOperation => {
		const value = getOperationValue(newOperation);

		let values : any = {
			projects: {text: null, value: newOperation.projects},
			operation_type_id: newOperation
				? { value, text: newOperation.text }
				: null,
			property_type_id: newOperation.projects ? [] : filtersTags?.property_type_id ?? [],
			constStatesID: [],
			currencyID: newOperation.operation_type_id === 1
				? {text: null, value: 1}
				: null,
			minPrice: undefined,
			maxPrice: undefined,
		}

		filterChanged(values);
	};

	useEffect(() => {
	  	if (filters?.operation_type_id && !!operationTypeList.length) {
			const currentId = filters?.operation_type_id === 1 && filters?.projects ? 10 : filters?.operation_type_id
			setSelectedValue(currentId)
		}
	}, [filters?.operation_type_id, filters?.projects, operationTypeList]);

	return {
		data: {
			options: operationTypeList,
			value: selectedValue,
			onChange,
			customKey: "operation_type_id",
		},
		show: true,
		labeled,
		label: "",
		inputType,
	};
};

export { useOperationType };
